import objectHash from 'object-hash';

export class Store {

	constructor ({
		name = 'default'
	} = {}) {
		this.name = name;

		this.previousState = {};
		this.state = {};
	}

	get storageKey () {
		return `${this.name}@`;
	}

	/**
	 * Delete all matching storage keys, if no `id` is given then delete all
	 * @param {string} [id]
	 */
	clear (id = '') {
		const storageKey = `${this.storageKey}${id}`;

		for (let key in sessionStorage) {
			if (key.startsWith(storageKey)) {
				sessionStorage.removeItem(key);
			}
		}
	}

	/**
	 * Performs a deep merge between the passed state and the current sate objects
	 * @param {any} state
	 * @returns {any}
	 */
	merge (state) {
		return {
			...structuredClone(this.state),
			...state
		};
	}

	/**
	 * @param {string} [id]
	 * @param {any} [defaultValue]
	 */
	get (id, defaultValue = {}) {
		// Get the storage object via it's id
		const storageKey = `${this.storageKey}${id}`;
		const storageItem = sessionStorage.getItem(storageKey);

		// If the storage item does not exist then use the default value provided
		this.state = storageItem
			? JSON.parse(sessionStorage.getItem(storageKey))
			: this.set(defaultValue);

		// Return the state reference
		return this.state;
	}

	/**
	 * @param {any} state
	 * @param {boolean} merge
	 */
	set (state, merge = false) {
		// Set previous state reference
		this.previousState = structuredClone(this.state);

		// Create merge if merge=true
		const workingState = merge
			? this.merge(state)
			: state;

		// Create a new id from the object contents
		const id = objectHash(workingState, {
			excludeKeys: key => key === 'id',
			unorderedArrays: true
		});

		// Create a storage key reference with the id inside
		const storageKey = `${this.storageKey}${id}`;

		// Create a copy of the state with the new id
		const record = {
			...workingState,
			id
		};

		// Push the copied state into the storage container
		sessionStorage.setItem(storageKey, JSON.stringify(record));

		// Update the reference to this.state to be the new record
		this.state = record;

		// Return the state reference
		return this.state;
	}
};
